import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { skip } from 'rxjs/operators';

import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { SessionStorage } from './session-storage';
import { STORAGE_KEY } from '../shared-ts/session-data';


@Injectable()
export class GroupsFilter {
  public groupsFilterComponentDisableSubject: Subject<boolean> = new Subject();
  public areSelectedGroupExempted: boolean | null = null;
  private _preventReload: boolean;
  private changes: any;
  private _preventProcessing: boolean;
  public redirectUrl: string;
  private isSuspended: boolean;
  private groupUpdateStream: Subject<number[]> = new Subject<number[]>();

  constructor(@Inject(SessionStorage) private storage: SessionStorage, private router: Router) {
    this._preventReload = true; // Prevent reload on initial value
    this.changes = new BehaviorSubject(this._storedValue || []);
    this.changes.pipe(skip(1)).subscribe(this._onUpdate.bind(this));
  }

  get _storedValue() {
    return this.storage.getKey(STORAGE_KEY) || null;
  }

  set _storedValue(value) {
    this.storage.setKey(STORAGE_KEY, value);
  }

  get value() {
    return this.changes.value;
  }

  public get groupUpdate$(): Observable<number[]> {
    return this.groupUpdateStream.asObservable();
  }

  public update(groupIds: number[], preventProcessing: boolean = false) {
    this._preventProcessing = preventProcessing;
    this.changes.next(groupIds);
  }

  public suspend() {
    this.isSuspended = true;
    this.update([], true);
  }

  public resume() {
    if (!this.isSuspended) { return; }
    this.isSuspended = false;
    this.update(this._storedValue, true);
  }

  public get groupsComponentDisable$(): Observable<boolean> {
    return this.groupsFilterComponentDisableSubject.asObservable();
  }

  public disableGroupsFilterComponent(flag: boolean): void {
    this.groupsFilterComponentDisableSubject.next(flag);
    if (flag) this.suspend();
    else this.resume();
  }

  private _onUpdate(groupIds: number[]) {
    if (this._preventProcessing) {
      this._preventProcessing = false;
      return;
    }
    // TODO Figure out a better way to handle dashboard reloading when groups filter change
    const router = this.router;
    const redirectUrl = router.url;
    if (redirectUrl) {
      this.redirectUrl = redirectUrl;
      this.groupUpdateStream.next(groupIds);
      router.navigate(['/reload'], { skipLocationChange: true });
    }
    this._storedValue = groupIds;
  }
}
